module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><h4>'+
((__t=( alias ))==null?'':__t)+
'</h4><table><tr><td>Last seen</td><td>'+
((__t=( time ))==null?'':__t)+
' <tr><td>Position</td><td>'+
((__t=( locationGPS.lat ))==null?'':__t)+
', '+
((__t=( locationGPS.lng ))==null?'':__t)+
' <tr> ';
 if(speed > 0){ 
__p+=' <td>Heading</td><td>'+
((__t=( heading ))==null?'':__t)+
' ';
 } 
__p+=' <tr><td>Speed</td><td>'+
((__t=( speed ))==null?'':__t)+
' <tr> ';
 if(ignition){ 
__p+=' <td>Ignition</td><td>'+
((__t=( (ignition)? 'On':'Off' ))==null?'':__t)+
' ';
 } 
__p+=' </td></tr></td></tr></td></tr></td></tr></td></tr></table></div>';
}
return __p;
};
